import React from 'react';
import type ServicedeskQueuesManageViewType from '@atlassian/jira-spa-apps-servicedesk-queues-manage-view/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskQueuesManageView = lazyForPaint<typeof ServicedeskQueuesManageViewType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-queues-manage-page", jiraSpaEntry: "async-servicedesk-queues-manage-page" */ '@atlassian/jira-spa-apps-servicedesk-queues-manage-view'
			),
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskQueuesManageView}
		pageId="spa-apps/servicedesk/queues/manage"
		shouldShowSpinner
	/>
);
